// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__5RCpU","range":"MonthRangeSwitch_range__2g79Q","disabled":"MonthRangeSwitch_disabled__7M94s"};